import React from 'react';

import { Box, Typography } from '@mui/material';

import { globalTheme } from '../../../../../../../shared/theme/theme';
import { ReviewStatisticsOverTimeBreakdownModel } from '../../../models/review-statistics-over-time-breakdown.model';
import { CustomTooltipProps } from '../../../shared/models/custom-tooltip-props.model';

export const CustomTooltipAvgRatingsChart = ({
  active,
  payload,
  label,
}: CustomTooltipProps<ReviewStatisticsOverTimeBreakdownModel>) => {
  if (active && payload && payload.length) {
    return (
      <Box
        component="div"
        sx={{
          backgroundColor: globalTheme.palette.appWhite.main,
          padding: 1,
          borderRadius: 1,
          boxShadow: '0px 0px 5px rgba(0,0,0,0.1)',
        }}
      >
        <Typography sx={{ fontSize: '12px', margin: 0 }}>
          {label} 2025: {payload[0].value.toFixed(2)} avg rating
        </Typography>
      </Box>
    );
  }
  return null;
};
